<style>

.bg{
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-image: url("/i/signup-bg-wizard.jpg");
  background-size: cover;
  color: black;
  padding: 20px;
  overflow-y: scroll;
}

.margin{
  margin-top: 50px;
}

.item{
  /* border: 1px red solid; */
  height: 150px;
  text-align: center;
  background-position: center center;
  background-repeat: no-repeat;
  background-origin: border-box;
  background-clip: border-box;
  background-size: cover;
  border-radius: 11px;
  border: 1px black solid;
  margin: 0 20px 20px 20px;
}
.item-text{
  margin-top: 8px;
  font-size: 24px;
  font-weight: bold;
}
.selected{
  box-shadow: 0 0 10px #7DE0FF;
  border: 3px #7DE0FF solid;
  height: 146px;
}
.item-text-selected{
  margin-top: 6px;
}
.check{
  height: 50px;
  text-align: right;
}
.icon-check{
  font-size: 50px;
  color: #7DE0FF;
  text-shadow: 1px 1px 6px #555;
}

.search{
  position: fixed;
  top: 45px;
  left: 0;
  right: 0;
  height: 37px;
  margin: 0 20px;
  background-color: rgba(0,0,0,0.8);
}
.has-search{
  height: 50px;
}

.nothing-here{
  font-size: 24px;
  margin: 20px;
}

.buttons{
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 10px 20px;
  background-color: black;
}
.has-buttons{
  height: 50px;
}
</style>

<Header back="{back}" on:back="{ () => { pop() } }">{title}</Header>
<div class="has-header"></div>

<div class="search">
  <SearchInput bind:value="{search}" on:search="{searchNow}"></SearchInput>
</div>
<div class="has-search"></div>

<Dialog show="{newUserShow}" title="" cancel="{false}" close="{false}" buttons="{ [ {text: 'Got It!', callback: 'close', disabled: false, }, ] }" on:close="{closeDialog}">
  <p>Search for all activities and things you're interested in.</p>
  <p>Tip: the more interests you include, the more activities and connections available!</p>
</Dialog>

{#if curItems.length > 0}

  {#each curItems as item, index }
    <div class="item {item.s ? 'selected' : ''}" style="background-image: linear-gradient( rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4) ), url('/categories/{item.p}.jpg')" on:click="{ () => { record(index); } }">
      <div class="check">
        {#if item.s}
          <i class="icon-check"></i>
        {/if}
      </div>
      <div class="item-text {item.s ? 'item-text-selected' : ''}">{item.t}</div>
    </div>
  {/each}

{:else}
  <div class="nothing-here">Nothing here yet.  Check back later!</div>
{/if}

<div class="has-buttons"></div>
<div class="buttons">
  <button on:click="{next}">Next</button>
</div>



<script>

import {push, pop, replace, location} from 'svelte-spa-router';
export let params = {};

import Header from "../../../../components/Header.svelte";
import SearchInput from "../../../../components/SearchInput.svelte";
import Dialog from "../../../../components/Dialog.svelte";

import InterestCategories from "../../../../helpers/InterestCategories.js";

let newUserShow = false;

// this is what gets listed.  sub categories are assigned to this to list out
let curItems = [];
let title = "Add Interests";

let back = false;

let items = InterestCategories;

import { onMount } from "svelte";
onMount(async () => {
  
  if ( localStorage.getItem("add-interests-new-user") == null) {
    localStorage.setItem("add-interests-new-user", 1)
  }
  newUserShow = localStorage.getItem("add-interests-new-user");
  
  setCategory();
});


function setCategory() {
  if (params.category == null || params.category == "") {
    back = false;
    curItems = items;
    title = "Add Interests";
  } else {
    back = true;
    for(let i in items) {
      if (items[i].t == params.category) {
        curItems = items[i].subCategories.sort(sortFunction);
        title = items[i].t;
        break;
      }
    }
  }
}


function sortFunction(a, b) {
  let nameA = a.t.toUpperCase(); // ignore upper and lowercase
  let nameB = b.t.toUpperCase(); // ignore upper and lowercase
  if (nameA < nameB) {
    return -1;
  }
  if (nameA > nameB) {
    return 1;
  }

  // names must be equal
  return 0;
}


function record(index) {
  
  if (title == "Add Interests" && search == "") {
    push("/signup/profile/personal/add-interests/" + curItems[index].t);
  } else {
    curItems[index].s = !curItems[index].s;
    
    // store to the server here
  }
}


let search = "";
function searchNow() {
  console.log("search:", search);
  
  if (search == "") {
    setCategory();
    return;
  }
  
  // a placeholder for searched items to go into
  let searchItems = [];
  
  // loop through top level items
  for (let i in items) {
    
    // search at the top level
    // the issue here is that we need to be able to decipher subCategories
    // if (items[i].t.toLocaleLowerCase().includes(search.toLocaleLowerCase()) == true) {
    //   let t = JSON.parse( JSON.stringify(items[i]) );
    //   delete t.subCategories;
    //   searchItems.push(items[i]);
    // }
    
    for (let j in items[i].subCategories) {
      
      if (items[i].subCategories[j].t.toLocaleLowerCase().includes(search.toLocaleLowerCase()) == true) {
        searchItems.push(items[i].subCategories[j]);
      }
      
    }
    
  }
  
  curItems = searchItems
}


function closeDialog() {
  newUserShow = false;
  localStorage.setItem("add-interests-new-user", 0);
}


function next() {
  push("/signup/profile/personal/questions");
}


</script>